
import {defineComponent, PropType} from "vue";
import {mapActions, mapState} from "pinia";
import Place, {isValidPlace} from "@wikicasa/common/model/Place";
import "../../style/vendor/leafleft.theme.scss";
import "../../style/components/placeSearch.scss";
//@ts-ignore
import {deepCopy} from "@utils/ObjectUtils";
//@ts-ignore
import StaticSpinner from "@vueEntry/StaticSpinner.vue";
import { usePlaceType } from "@wkComposables/usePlaceType";
//@ts-ignore
import {usePlaceName} from "@wkComposables/usePlaceName";
//@ts-ignore
import {useSearch} from "@wkComposables/useSearch";
import {PublicValuation} from "../Types/PublicValuation";
import { useVuelidate } from "@vuelidate/core";
import {requiredIf} from "@vuelidate/validators";
//@ts-ignore
import {PLACE_TYPE} from "@customTypes/PlaceType";
//@ts-ignore
import {getDistrictsByZoneId, getPlace, getZones} from "@services/placesAPI";
//@ts-ignore
import BaseAutocomplete from "@vueEntry/UIKitComponents/BaseAutocomplete.vue";
//@ts-ignore
import {SelectOptions} from "@customTypes/BaseInputTypes";
//@ts-ignore
import {getPlacesAddressAutocomplete} from "@services/geographyAPI";
//@ts-ignore
import {GooglePredictionType} from "@customTypes/GAutocompleteTypes";
//@ts-ignore
import {getPlaceFromGAutocomplete} from "@utils/GAutocompleteUtils";
//@ts-ignore
import BaseInput from "@vueEntry/UIKitComponents/BaseInput.vue";
//@ts-ignore
import BaseButton from "@vueEntry/UIKitComponents/BaseButton.vue";
//@ts-ignore
import CheckboxBtn from "@vueEntry/UIKitComponents/Checkbox/CheckboxBtn.vue";
import RadioButton from "@vueEntry/UIKitComponents/Radio/RadioButton.vue";
import {isArrNullOrEmpty} from "@utils/ArrayUtils";
import {useSearchBeanStore} from "@store/SearchBeanStore";

enum CONTRACTTYPE {
    SALE = "sale",
    RENT = "rent",
    AUCTION = "auction",
    AGENCY = "agency",
    VALUATE = "valuate",
    TREND = "trend",
}

export default defineComponent({
    name: "PlaceBox",
    components: {
        RadioButton,
        BaseInput,
        BaseAutocomplete,
        BaseButton,
        StaticSpinner,
        CheckboxBtn
    },
    props: {
        customListingTypologyURL: {
            type: String,
            default: ""
        },
        useContractType: {
            type: Boolean,
            default: true
        },
        agencyFilter: {
            type: Object,
            default: null
        },
        hasError: {
            type: Boolean
        },
        listing: {
            type: Boolean
        },
        valuation: {
            type: Boolean
        },
        freesearch: {
            type: Boolean
        },
        freesearchDefault: {
            type: String
        },
        place: {
            type: Object as PropType<Place>,
        },
        showPlaceMapDropDown: {
            type: Boolean,
            default: true
        },
        dropDownMenuActive: {
            type: Boolean,
            default: false
        },
        contractType: {
            type: String as PropType<CONTRACTTYPE>,
        },
        closeDropDown: {
            type: Boolean,
            default: false
        },
        isAgency: {type: Boolean}
    },
    emits: ["focus-in", "hide-place-modal", "show-map", "new-place", "emit-place"],
    setup(){
        const {
            localityList,
            zoneList,
            searchBeanModal,
            localitySelected,
            zoneIDsSelected,
            zoneModifiedByUser,
            districtSelected,
            districtsObj,
            //Methods
            convertEnergyClassFilter,
            convertFloor,
            resetSearchBeanZonesAndLocalities,
            updateSearchModal,
            updateSearchModalAndPlace,
            fixSearchBean,
            initZonesAndLocalities,
            areAllDistrictsSelected,
            isZoneOrLocalitySelected,
            areZonesAndLocalitiesEmpty,
            areZonesAndLocalitiesFilled,
            getSingleSelectedDistrict,
            getZoneById,
            resetZoneAndLocalities,
            isZoneSelected,
            isLocationSelected,
            isDistrictSelected,
            insertDistrictByZoneId,
            onPlaceLIClick,
            onDistrictClick
        } = usePlaceType()

        const {
            currentPlaceName, //Refs
            locationLabel, zonesLabel, //Computed
            //Methods
            updateLocationName,
            updateZoneName,
            updateSingleDistrictName,
            updateGenericPlaceName,
            updateCityName
        } = usePlaceName()

        const {
            search
        } = useSearch()

        return {
            v$: useVuelidate(),
            //Refs
            currentPlaceName,
            //Computed
            locationLabel, zonesLabel,
            //Methods
            updateLocationName,
            updateZoneName,
            updateSingleDistrictName,
            updateGenericPlaceName,
            updateCityName,
            //usePlaceType
            localityList,
            zoneList,
            searchBeanModal,
            localitySelected,
            zoneIDsSelected,
            zoneModifiedByUser,
            districtSelected,
            districtsObj,
            //Methods
            convertEnergyClassFilter,
            convertFloor,
            resetSearchBeanZonesAndLocalities,
            updateSearchModal,
            updateSearchModalAndPlace,
            fixSearchBean,
            initZonesAndLocalities,
            areAllDistrictsSelected,
            isZoneOrLocalitySelected,
            areZonesAndLocalitiesEmpty,
            areZonesAndLocalitiesFilled,
            getSingleSelectedDistrict,
            getZoneById,
            resetZoneAndLocalities,
            isZoneSelected,
            isLocationSelected,
            isDistrictSelected,
            insertDistrictByZoneId,
            onPlaceLIClick,
            onDistrictClick,
            //useSearch
            search
        }
    },
    validations(){
        return {
            placeTest: {
                required: requiredIf(function () {
                    // @ts-ignore
                    return this.valuation;
                }),
                function(): boolean {
                    return isValidPlace(this.placeTest!)
                }
            }
        }
    },
    data() {
        return {
            disableCb: true,
            valuationAddress: "",
            autocompleteValue: "",
            freesearchValue: "",
            placeTest: null as Place | null,
            // searchBeanModal: getDefaultSearchBean(),
            showMapModal: false,
            mapPlace: null as Place | null,
            aroundMe: false,
            showZoneModal: false,
            zoneModifiedByUser: false,
            tempPlace: null as Place | null,
            showClearBtn: false,
            publicValuation: {
                realEstateValuation: {
                    address: "",
                    sqM: null,
                    rooms: null,
                    typologyID: 0,
                },
                privateValuation: true,
                contactDesired: null,
                email: "",
                name: "",
                surname: "",
                phone: null
            } as PublicValuation,
            dropDownMenu: false,
            spinnerIcon: false,
            cinputSearchBox: "cinputSearchBox",
            dinamicResult: {}
        }
    },
    computed: {
        placeholder(): string {
            return this.isAgency ? "Inserisci luogo" : this.labels.insertSearchCity
        },
        labels(): Record<string, string> {
            return window["_labels"];
        },
        containerClasses(): string {
            if (!this.listing || this.freesearch)
                return "";

            return this.showZoneModal || this.dropDownMenu ? "" : "";
        },
        isSearchReady(): boolean {
            return !(!this.searchBean.cityURL && !this.searchBean.polygonFromMap);
        },
        localitiesLabel(): string {
            return this.labels.localities;
        },
        cdn(): string {
            return window["_cdn"]
        },
        hasValuationAddress(): boolean {
            return !!this.tempPlace?.address;
        },
        backdrop(): HTMLElement {
            return document.getElementById("modalBackdropForNewMobileHome") as HTMLElement;
        },
        ...mapState(useSearchBeanStore, ["searchBean"])
    },
    watch: {
        showZoneModal(cur, prev){
            this.disableCb = cur
        },
        currentPlaceName(cur, prev) {
            this.autocompleteValue = cur;
        },
        searchBean: {
            handler(cur, prev) {
                if (cur.polygonFromMap) {
                    this.zoneList = [];
                    this.zoneIDsSelected = [];
                    this.localityList = [];
                    this.localitySelected = undefined;
                    this.showZoneModal = false;
                    this.zoneModifiedByUser = false;
                    this.districtsObj = {}
                    this.districtSelected = {}
                }
                if (!this.searchBean.polygonFromMap && !this.searchBean.cityDisplayName && !this.searchBean.cityURL && !this.searchBean.cityName)
                    this.currentPlaceName = "";
                //this is because mapModal emit the place to the searchboxhome and the only way to know that the placename need to be update is to watch it
                else if (this.searchBean.polygonFromMap)
                    this.updatePlaceName()
                // else
                //     this.updatePlaceName();
            },
            deep: true
        },
        closeDropDown: {
            handler(cur: boolean, prev: boolean) {
                this.dropDownMenu = !cur;
                this.showZoneModal = !cur;
            }
        },
        dropDownMenu(cur: boolean): void {
            if (!cur)
                this.showClearBtn = false;
        }
    },
    async created() {
        this.updateSearchModal(JSON.parse(JSON.stringify(this.searchBean)));
        this.convertEnergyClassFilter();
        this.convertFloor();

        this.freesearchValue = this.freesearchDefault ?? "";
        this.dropDownMenu = this.dropDownMenuActive;

        //This listener will be used to close the zone modal whenever the user click outside the zones/localities dropdown
        document.body.addEventListener("click", (event: Event) => {
            const clickedItem = event.target as HTMLElement
            if (this.showZoneModal) {
                this.showZoneModal = false;
            }

            if (this.dropDownMenu && !clickedItem.className.includes("exclude-event-target")) {
                this.dropDownMenu = false;
            }
            // this.currentPlaceName = "";
        });
        if (this.place)
            this.placeTest = deepCopy(this.place);

        const {zoneIdList, localityIdList, cityId} = this.searchBeanModal;

        //Just one zone
        if (this.placeTest?.zoneID && !this.placeTest.districtID)
            this.zoneIDsSelected = [this.placeTest.zoneID]
        else if (zoneIdList && zoneIdList.length > 0 && this.placeTest?.placeType !== "D") {

            this.zoneIDsSelected = zoneIdList;
        } else if (this.placeTest?.placeType === PLACE_TYPE.DISTRICT) {
            this.searchBeanModal.zoneId = null
            this.searchBeanModal.zoneIdList = [];
            this.zoneIDsSelected = []
        }

        if (cityId) {
            await this.initZonesAndLocalities(getZones(cityId))
            if (!localityIdList) return;
            this.localitySelected = this.localityList.find(l => l.localityID === localityIdList[0]);

        }
        this.updatePlaceName();
    },
    methods: {
        async initSingleDistrict(zoneId: number, districtId: number) {
            const districts = await getDistrictsByZoneId(zoneId);
            const singleDistrict = districts.find(d => d.districtID === districtId)
            // this.$set(this.districtsObj, singleDistrict?.zoneID, [singleDistrict])
            this.districtsObj[singleDistrict?.zoneID] = [singleDistrict]
            //Adding the district to the district object
            this.insertDistrictByZoneId(zoneId, districtId)
        },
        async onInputChangeCb(query: string): Promise<any[] | void> {
            if (!query)
                return

            const res = await getPlacesAddressAutocomplete(query, 10)
            return res.map((r: GooglePredictionType) => ({label: r.description, id: r.place_id}));
        },
        async optionSelectedCb(selectedEl: SelectOptions): Promise<void> {
            const {place} = await getPlaceFromGAutocomplete(`${selectedEl.id}`, selectedEl.label);
            this.disableCb = true;
            this.tempPlace = place;
            this.valuationAddress = selectedEl.label;
            this.confirmPlace();
        },
        handleClick(): void {
            this.disableCb = false

            if (this.valuation)
                return;

            if (!this.showZoneModal)
                this.dropDownMenu = true;
        },
        managePlace(selectedPlace: Place) {
            this.disableCb = true;

            this.resetSearchBeanZonesAndLocalities();
            const updatePlaceCb = (): void => {
                this.placeTest = {...selectedPlace};
                this.confirmPlace();
            };

            if (selectedPlace.placeType == PLACE_TYPE.CITY) {
                this.updateSearchModalAndPlace(selectedPlace, () => {
                    this.placeTest = {...selectedPlace};
                });
                if (this.contractType !== CONTRACTTYPE.TREND) {
                    this.emitPlace();
                    this.updatePlaceName();

                    this.initZonesAndLocalities(
                        getZones(selectedPlace.cityID),
                        () => {
                            this.openZoneModal()
                        },

                        //that means there are no zones
                        () => {
                            this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb)
                        }
                    );
                } else {
                    this.confirmPlace();
                    this.updatePlaceName();
                }
            } else if (selectedPlace.placeType == PLACE_TYPE.DISTRICT) {
                this.initSingleDistrict(selectedPlace.zoneID, selectedPlace.districtID).then(() => {
                    this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb)
                })

            } else
            //e.g. if the selected
            //option is a province...
                this.updateSearchModalAndPlace(selectedPlace, updatePlaceCb);

        },
        openDropDown() {
            this.dropDownMenu = true;
        },
        fromDropDownToZoneModal() {
            this.dropDownMenu = false;
            this.showClearBtn = true;
            if (this.contractType === CONTRACTTYPE.TREND)
                this.confirmPlace();

            const hasAnyZonesOrLocalities = this.zoneList.length + this.localityList.length;
            if (hasAnyZonesOrLocalities)
                this.showZoneModal = true;

            if(isArrNullOrEmpty(this.zoneList)){
                (document.getElementById("ba_place-ac") as HTMLInputElement).select()
            }

        },
        updatePlaceNameAndEmit() {
            this.updatePlaceName();
            this.emitPlace();
        },
        updatePlaceName() {
            /* LOCALITY */
            if (this.localitySelected || (this.placeTest?.localityID && !this.zoneIDsSelected.length)) {
                this.updateLocationName(this.localitySelected ?? this.placeTest);
                return;
            }
            /* DRAWN AREA MAP */
            // eslint-disable-next-line max-len
            if ((this.listing && !!this.searchBeanModal.polygonFromMap && this.searchBeanModal.placeType != "I")
                || (!this.listing && !!this.searchBean.polygonFromMap && this.searchBean.placeType != "I")) {
                this.currentPlaceName = this.labels.mapAreaDrawn;
            }
            /* VACATION PLACE LIKE CINQUE TERRE */
            else if (!!this.searchBean.polygonFromMap && this.searchBean.placeType == "I") {
                this.currentPlaceName = this.searchBean?.cityDisplayName;
            } else if (this.searchBeanModal.placeType == PLACE_TYPE.AREA) {
                this.updateGenericPlaceName(this.placeTest);
            } else {
                //Zones and district greater than one
                if(this.zoneIDsSelected.length >= 0 || this.searchBeanModal.districtIdList?.length >= 0){
                    if ([PLACE_TYPE.PROVINCE, PLACE_TYPE.AREA_OF_INTEREST, PLACE_TYPE.REGION, PLACE_TYPE.LOCALITY].includes(this.placeTest?.placeType || ""))
                        this.updateGenericPlaceName(this.placeTest);
                    // eslint-disable-next-line max-len
                    else if ((!this.searchBeanModal.districtIdList?.length && !this.searchBeanModal.districtId) && (!this.zoneIDsSelected.length && !this.searchBeanModal.zoneId))
                        this.updateCityName(this.placeTest);
                    else if (!this.zoneIDsSelected.length && this.searchBeanModal.districtIdList?.length === 1)
                        this.updateSingleDistrictName(this.getSingleSelectedDistrict());
                    else if (this.zoneIDsSelected.length === 1 && !this.searchBeanModal.districtIdList?.length)
                        this.updateZoneName(this.getZoneById(this.zoneIDsSelected[0]), 1);
                    else
                        this.updateZoneName(this.placeTest, this.zoneIDsSelected.length + this.searchBeanModal.districtIdList?.length);
                }
            }
        },
        openZoneModal(): void {
            if ((this.zoneList.length + this.localityList.length) && !this.valuation)
                this.showZoneModal = true
        },
        async getPlaceFn(query: string): Promise<SelectOptions[] | void> {
            if (!query)
                return;

            this.autocompleteValue = query;
            this.resetZoneAndLocalities();
            const res = await getPlace(query, "C,P,Z,L,I,R,A,D")
            //@ts-ignore
            return res.map((place, index) => ({id: index, label: place.displayName, payload: place}));
        },
        confirmPlace() {
            this.spinnerIcon = true;
            this.updatePlaceName();
            if (this.freesearch) {
                this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter, {value: this.freesearchValue});
            } else if (this.valuation) {
                this.publicValuation.realEstateValuation.address = this.tempPlace?.address || "";
                this.placeTest = this.tempPlace;
                this.tempPlace = null;
                this.emitPlace();
            } else {
                this.fixSearchBean(
                    () => {
                        this.placeTest = this.zoneList.find((plc: Place) => plc.zoneID == this.searchBeanModal.zoneId) || this.placeTest;
                        return this.placeTest?.zoneURL;
                    },
                    () => {
                        this.placeTest = this.localitySelected ? {...this.localitySelected} : this.placeTest;
                        return this.placeTest?.zoneURL;
                    },
                    () => {
                        return this.placeTest?.zoneURL;
                    },
                );
                this.updatePlaceName();
                this.searchBeanModal.polygonFromMap = "";
                this.searchBeanModal.polygonForDB = undefined;
                if (this.listing) {
                    this.updateSearchBean(this.searchBeanModal);
                    this.search(this.listing, this.customListingTypologyURL, this.useContractType, this.agencyFilter);
                } else {
                    this.emitPlace();
                    this.dropDownMenu = false;
                }
            }
        },
        openMapDraw(): void {
            if (this.listing)
                this.hidePlaceModal();
            this.showMap();
        },
        closeModal(): void {
            document.body.classList.remove("modal-open");
            this.backdrop?.classList.remove("show", "d-block");
            this.backdrop?.classList.add("d-none");
        },
        hidePlaceModal() {
            this.closeModal();
            this.$emit("hide-place-modal", true);
        },
        showMap() {
            this.$emit("show-map", {
                aroundMe: this.aroundMe,
                searchBean: this.searchBeanModal,
            });
        },
        emitPlace() {
            /* closes keyboard after sending the place on safari */
            this.updatePlaceName();

            if (this.valuation) {
                this.$emit("new-place", this.placeTest);
            } else {
                //Ensuring that the place and the searchBeanModal have updated before emitting them
                this.$nextTick(() => {
                    this.$emit("emit-place", {
                        place: this.placeTest,
                        aroundMe: false,
                        radius: 0,
                        searchBean: deepCopy(this.searchBeanModal),
                        polygon: ""
                    });
                })
            }

        },
        // ...mapMutations(["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
        ...mapActions(useSearchBeanStore, ["setSearchBean", "setSearchBeanByKey", "updateSearchBean"])
    },
})
